import apiClient from './apiClient';
import { GET_RESTRICTIONS } from '../constants/UriConstants';
import { DishCharacteristicInterface } from '../types/DishCharacteristicInterface';

const getRestrictions = (): Promise<DishCharacteristicInterface[]> =>
  apiClient.get(GET_RESTRICTIONS).then((response) => response.data);

export default getRestrictions;
